// 智能验证
import { computed, ref } from 'vue';
import { mb_t } from '@star/languages';
import { storeToRefs, useAppStore, useTenantStore } from '@star/stores';
import { useScriptTag, useWindowSize } from '@vueuse/core';
// import { keys } from 'lodash-es';
import { showNotify } from 'vant';
import { includes } from 'lodash-es';

// 1登录  2注册
type LoginType = 1 | 2;

export default function useAiValidate(type?: LoginType, cb?: (params: Record<string, any>) => Promise<any>) {
  const { sysLoginOptions, sysRegisterOptions, aiCaptcha } = storeToRefs(useTenantStore());
  const { language } = storeToRefs(useAppStore());
  const verifyCode = ref<string>();
  const loading = ref<boolean>(false);
  const { width } = useWindowSize();
  const DOM_ID = 'aiValidate2';

  const getTimestamp = () => {
    return Math.floor(Date.now() / (1000 * 60));
  };

  const isLoad = computed(() => {
    return !!captchaIns.value;
  });

  const captchaIns = computed(() => {
    if (includes([1, 2], type)) {
      return type === 1 ? aiCaptcha.value.loginInstance : aiCaptcha.value.registerInstance;
    }
    return undefined;
  });

  const lang = computed(() => {
    return language.value === 'cn' || language.value === 'zh' ? 'zh-CN' : language.value;
  });

  const isH5 = computed(() => {
    return width.value < 768;
  });

  const sysConfigOption = computed(() => {
    return type === 1 ? sysLoginOptions.value : sysRegisterOptions.value;
  });

  const captchaType = computed(() => {
    const CAPTCHA_MODE: any = type === 1 ? 'CUST_LOGIN_CAPTCHA_MODE' : 'CUST_REGISTER_CAPTCHA_MODE';
    return sysConfigOption.value?.[CAPTCHA_MODE]?.[isH5.value ? 'Z2_M_SMART_CAPTCHA_MODE' : 'Z2_PC_SMART_CAPTCHA_MODE'];
  });

  const onSuccess = () => {};

  const initCaptcha = () => {
    console.log(window.initNECaptcha, 'initCaptcha');
    if (!window.initNECaptcha) {
      loading.value = false;
      return;
    }
    console.log(captchaType.value, sysConfigOption.value, 'xxxxxxxxxxxxxxxxxxxxxxxxxxxx');
    loading.value = true;
    window.initNECaptcha(
      {
        // captchaId: '4d0c37eabd5b4b93ad498e8b6a3231a0', // 智能点选
        captchaId: sysConfigOption.value?.YIDUN_CAPTCHA_ID?.['CAPTCHA_ID_' + captchaType.value],
        element: captchaType.value === '2' ? `#${DOM_ID}` : null,
        mode: captchaType.value === '2' ? 'float' : 'popup',
        width: '320px',
        feedbackEnable: false, // 业务方关闭反馈入口
        lang: lang.value,
        apiVersion: 2,
        customStyles: {
          imagePanel: {
            borderRadius: 10,
          },
          controlBar: {
            textColor: '#8e91aa',
            borderColor: '#dfe1ea',
            borderColorMoving: '#dfe1ea',
            borderColorSuccess: '#dfe1ea',
            borderColorError: '#dfe1ea',
            background: '#f0f2f4',
            backgroundMoving: 'linear-gradient(270deg, rgba(55, 73, 233, 0.48) 0%, rgba(55, 73, 233, 0.08) 100%)',
            backgroundSuccess:
              'linear-gradient(270deg, rgba(35, 196, 148, 0.48) 14.18%, rgba(35, 196, 148, 0.08) 100%)',
            backgroundError: 'linear-gradient(270deg, rgba(215, 80, 80, 0.48) 0%, rgba(215, 80, 80, 0.08) 100%)',
            height: 40,
            borderRadius: 10,
            // slideIcon: 'https://yidunfe.nos-jd.163yun.com/moving1669028036380.png',
            // slideIconMoving: 'https://yidunfe.nos-jd.163yun.com/moving1669028036380.png',
            // slideIconSuccess: 'https://yidunfe.nos-jd.163yun.com/success1669028036503.png',
            // slideIconError: 'https://yidunfe.nos-jd.163yun.com/error1669028036362.png'
          },
          gap: 24,
        },
        onClose: function () {
          console.log('============== onClose ================');
          // 弹出关闭结束后将会触发该函数
        },
        onVerify: function (err: any, data: any) {
          // console.log(data, cb,'mmmmmmmmmmmmmmmmmmmmmmmmm');
          if (err) return;
          verifyCode.value = data.validate;
          captchaType.value !== '2' && cb?.({ validate: verifyCode.value });
        },
      },
      function onload(instance: any) {
        console.log(instance, '============== instance ================');
        // captchaIns.value = instance;
        if (type === 1) {
          aiCaptcha.value.loginInstance = instance;
        } else {
          aiCaptcha.value.registerInstance = instance;
        }
        loading.value = false;
      },
      function onerror() {
        loading.value = false;
        showNotify({ type: 'warning', message: mb_t('智能验证加载失败，请刷新重试！') });
      }
    );
  };

  const { load, unload } = useScriptTag(
    `${location.protocol}//cstaticdun.126.net/load.min.js?t=${getTimestamp()}`,
    () => {
      aiCaptcha.value.isLoadScript = true;
      // initCaptcha();
    },
    { manual: true }
  );

  // 加载
  const loadCaptcha = () => {
    load();
    // loading.value = true;
    // verifyCode.value = undefined;
    // if (aiCaptcha.value.isLoadScript) {
    //   initCaptcha();
    // } else {
    //   await load();
    // }
  };

  const unloadCaptcha = async () => {
    captchaIns.value?.destroy?.();
    if (includes([1, 2], type)) {
      if (type === 1) {
        aiCaptcha.value.loginInstance = undefined;
      } else {
        aiCaptcha.value.registerInstance = undefined;
      }
    }
  };

  const showVerify = async (_params: Record<string, any>) => {
    if (captchaType.value === '2') {
      if (verifyCode.value) {
        await cb?.({ ..._params, validate: verifyCode.value });
        await captchaIns.value?.refresh?.();
      } else {
        showNotify({ type: 'warning', message: mb_t('请先完成验证！') });
      }
    } else {
      await captchaIns.value?.refresh?.();
      await captchaIns.value?.verify?.();
    }
    verifyCode.value = undefined;
  };

  return {
    loadCaptcha,
    initCaptcha,
    unloadCaptcha,
    showVerify,
    captchaIns,
    isLoad,
    loading,
    verifyCode,
  };
}
